import React, { FC } from 'react';
import style from './Navigation.module.scss';

type SubNavHeadingProps = {
  children: string;
};

const SubNavHeading: FC<SubNavHeadingProps> = ({ children }) => (
  <h4 className={style.subNavHeading}>
    {children}
  </h4>
);

export default SubNavHeading;
